type CardSize = 'small' | 'medium' | 'large' | 'xlarge'

export const CUSTOM_BUMPER_PRODUCT_SKUS: {[key: string]: boolean} = {
  'IP0516-CST-Group' : true, // color training
  'IP0520-CST-Group' : true, // black training
  'IP0537-CST-Group' : true, // color urethane
  'IP0538-CST-Group' : true, // black urethane
  'IP0535-CST-Group' : true, // hg
}

export const TRAP_BAR_BUNDLE_SKU = 'TB-3-BUNDLE'

export const RACKBUILDER_FTX: string[] = ['FM-6-GROUP', 'FM-HR-GROUP', 'FM-HR-TWIN-GROUP', 'FM-6-TWIN-GROUP', 'FML-HR-GROUP', 'FML-6-GROUP', 'INDY-GROUP', 'SLINGER-X-GROUP', 'ML-SLINGER-X-GROUP']

// These are the Bundle skus that get custom thumbnails
export const RACKBUILDER_BUNDLES: string[] = ['FM-6-BUNDLE', 'FM-HR-BUNDLE', 'FM-HR-TWIN-BUNDLE', 'FM-6-TWIN-BUNDLE', 'FML-HR-BUNDLE', 'FML-6-BUNDLE', 'RM-RHINO-RACK-BUNDLE', 'INDY-GROUP', 'SLINGER-X-BUNDLE', 'ML-SLINGER-X-BUNDLE']
export const RACKBUILDER_FTX_ADDON: string[] = ['FM-6-TRAINER-GROUP', 'FML-6-TRAINER-GROUP', 'FM-6-TWIN-TRAINER-GROUP', 'FML-HR-TRAINER-GROUP', 'INDY-GROUP', 'SLINGER-X-ADD-ON-BUNDLE', 'ML-SLINGER-X-ADD-ON-BUNDLE']
export const RACKBUILDER_RHINO_DROP: string[] = ['FM-RHINO-GROUP']
export const ALL_RACKBUILDER = RACKBUILDER_RHINO_DROP.concat(RACKBUILDER_FTX_ADDON).concat(RACKBUILDER_FTX)


export const DYNAMIC_IMG_BY_SKU: {[key: string] : {folder: string, options: boolean, useAsThumb?: boolean}[]} = {
  MONSTERMASS: [
    { folder: '/dynamic/storage_test_4/', options: true },
  ],
  CUSTOMOHIO_NEW: [
    { folder: '/dynamic/CUSTOMOHIO_NEW-1675873180367/', options: false }, // Shaft with rogue logo
    { folder: '/dynamic/CUSTOMOHIO_NEW-1675953816358/', options: true, useAsThumb: true }, // Angle view of bushing
    { folder: '/dynamic/CUSTOMOHIO_NEW-1675884097860/', options: true }, // Angle view of sleeve
    { folder: '/dynamic/CUSTOMOHIO_NEW-1675874865543/', options: false }, // Add shaft text
    { folder: '/dynamic/CUSTOMOHIO_NEW-1675877694910/', options: true }, // Add collar text
  ],
  'RA0539-NFL-Group': [
    { folder: '/dynamic/CUSTOMOHIO_NEW-1675874865543/', options: false }, // Add shaft text
    { folder: '/dynamic/CUSTOMOHIO_NEW-1675953816358/', options: true, useAsThumb: true }, // Angle view of bushing
    { folder: '/dynamic/CUSTOMOHIO_NEW-1675884097860/', options: true }, // Angle view of sleeve
    { folder: '/dynamic/CUSTOMOHIO_NEW-1675873180367/', options: false }, // Shaft with rogue logo
  ],
  CUSTOMBELLA_NEW: [
    { folder: '/dynamic/CUSTOMBELLA_NEW-1675873533288/', options: false }, // Shaft with rogue logo
    { folder: '/dynamic/CUSTOMBELLA_NEW-1675954290820/', options: true, useAsThumb: true }, // Angle view of bushing
    { folder: '/dynamic/CUSTOMBELLA_NEW-1675953106480/', options: true }, // Angle view of sleeve
    { folder: '/dynamic/CUSTOMBELLA_NEW-1675875016618/', options: false }, // Add shaft text
    { folder: '/dynamic/CUSTOMBELLA_NEW-1675877918100/', options: true }, // Add collar text
  ],
  CUSTOMOHIOPOWER_NEW: [
    { folder: '/dynamic/CUSTOMOHIOPOWER_NEW-1675874215741/', options: false }, // Shaft with rogue logo
    { folder: '/dynamic/CUSTOMOHIOPOWER_NEW-1675955441875/', options: true, useAsThumb: true }, // Angle view of bushing
    { folder: '/dynamic/CUSTOMOHIOPOWER_NEW-1675955681391/', options: true }, // Angle view of sleeve
    { folder: '/dynamic/CUSTOMOHIOPOWER_NEW-1675876106486/', options: false }, // Add shaft text
    { folder: '/dynamic/CUSTOMOHIOPOWER_NEW-1675883934265/', options: true }, // Add collar text
  ],
}

export const LOCKED :{[sku: string] : string} = {
  HW1012: 'This product is available exclusively for 2023 Invitational Premium ticket holders. Purchases limited to one shirt per account.',
}

// `product.visibility = 4` means that this product can be accessed directly via its url
// Otherwise, it is an "internal" product, like "Size medium blue shirt", that is only accessible via its parent product.
export const VISIBLE = 4

export const CARD_COUNT: Record<CardSize, number>= {
  small  : 8,
  medium : 20,
  large  : 40,
  xlarge : 80,
}